var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 9H6.375V16H3.25V9H0.71875V6.09375H3.25V3.90625C3.27083 2.63542 3.61458 1.66667 4.28125 1C4.96875 0.333333 5.88542 0 7.03125 0C7.61458 0 8.125 0.03125 8.5625 0.09375C9.02083 0.15625 9.26042 0.1875 9.28125 0.1875V2.65625H8.03125C7.40625 2.67708 6.97917 2.84375 6.75 3.15625C6.5 3.44792 6.375 3.80208 6.375 4.21875V6.09375H9.15625L8.71875 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b195fd35ba3bfb3051e088a833357171.svg";
export { ForwardRef as ReactComponent };